import { render, staticRenderFns } from "./xeGoalUsageSetting.vue?vue&type=template&id=5b13ac47"
import script from "./xeGoalUsageSetting.vue?vue&type=script&lang=js"
export * from "./xeGoalUsageSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports